import { BackgroundServiceServiceType } from "cpl-react-common/components/Enums/BackgroundServiceServiceType";

export function getRedirectRouteForServiceType(serviceType: BackgroundServiceServiceType): string {
  let route = "";
  switch (serviceType) {
    case BackgroundServiceServiceType.Test:
      route = "/CPLTest";
      break;
    case BackgroundServiceServiceType.ServiceChargeInvoicingPreList:
      route = "/ServiceChargeInvoicing/Wizard";
      break;
    case BackgroundServiceServiceType.AnticipatedExpenditureReport:
      route = "/AnticipatedExpenditure";
      break;
    case BackgroundServiceServiceType.ServiceChargeSummaries:
      route = "/ServiceChargeInvoicing";
      break;
  }
  return route;
}
